<template>
<div class="foruwizard-step">
  <h1 class="foruwizard-step-header">Укажите свой адрес</h1>
  <div class="foruwizard-step-content">
    <div class="foruwizard-step-header-small">Адрес компании <span class="text-negative">*</span></div>
    <div class="form-group foruwizard-form-group foruwizard-form-group-step-2" style="max-width: 416px">
      <q-form autocomplete="off" ref="addressForm">
        <div style="max-width: 386px">


        <vue-autosuggest :class="{ inputError: isRed, inputNotEmpty: isNotEmpty }" :suggestions="suggestions" :getSuggestionValue="getSuggestionValue" @selected="onSelected" @input="suggestAddr" :limit="10" :input-props="inputProps" v-model="company.address">
          <template slot-scope="{ suggestion }">
            <div>
              <!-- <b>{{suggestion.item.name}}</b> - {{suggestion.item.topping.map(topping => topping.type).join(", ")}} -->
              <!-- <b>{{suggestion.item.value}} - {{suggestion.item.data.address.unrestricted_value}}</b> -->
              <b>{{suggestion.item.value}}</b>

            </div>
          </template>
        </vue-autosuggest>

        <iframe class="foruwizard-map" :src="'https://www.google.com/maps?q='+company.address+'&t=&z=13&ie=UTF8&iwloc=&output=embed'" frameborder="0" v-if="loaded"></iframe>
</div>

        <div class="q-mt-lg">
          <div class="foruwizard-step-header-small">Телефон</div>
          <q-input color="primary" outlined v-model="company.phone" v-on:input="updateVars" label="Телефон для связи" mask="+# (###) ### - ## - ##" />
          <div class="foruwizard-step-header-small q-mt-lg">Email <span class="text-negative">*</span></div>
          <q-input color="primary" :rules="[  val => val && val.length > 0 && checkEmail(val) ]" lazy-rules outlined v-model="company.email" v-on:input="updateVars" label="Email для связи" type="email" />
          <!--<q-input color="primary" :rules="[  val => val && val.length > 5 && checkEmail(val) ]" outlined v-model="company.email" v-on:input="updateVars" label="Email для связи" type="email" />-->
          <!--<q-input color="primary" :rules="[ email, val => val && val.length > 0 || 'Укажите email']" outlined v-model="company.email" v-on:input="updateVars" label="Email для связи" type="email" />-->
        </div>
      </q-form>
    </div>
    <div class="form-group foruwizard-form-group-bottom">
      <a href="javascript:void(0)" @click="nextStep()" class="foruwizard-btn-salmon">Далее</a>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import { VueAutosuggest } from 'vue-autosuggest';

export default {
  data: function(){
    console.log("uuuuUUUUUUUUUUUU", this.propObj);
    return {
      isNotEmpty: this.isNotEmpty || false,
      isRed: this.isRed,
      company: {
        name: this.propObj.data.name,
        address: this.propObj.data.address,
        phone: this.propObj.data.phone,
        email: this.propObj.data.email,
        category: this.propObj.data.category,
        description: this.propObj.data.description,
        facebook: this.propObj.data.facebook,
        instagram: this.propObj.data.instagram,
        vkontakte: this.propObj.data.vkontakte,
        template_id: this.propObj.data.template_id
      },
      loaded: false,
      phone: "",
      inputProps: {
        id: "autosuggest__input",
        // placeholder: "Укажите Адрес"
      },
      suggestions: []
    }
  },
  props: {
    propObj: {type: Object},
    myNextStep: {type: Function}
  },
  components: {
    VueAutosuggest
  },
  methods: {
    checkEmail(val){
      var re = /\S+@\S+/;
      return re.test(val);
    },
    nextStep: function(){

      if (this.company.address === '' || this.company.address === undefined) {
        this.isRed = true;
      }
      this.$refs.addressForm.validate().then(success => {
        if (success) {
          this.myNextStep(3);
        }
      })
    },
    getSuggestionValue(suggestion){
      return suggestion.item.value
    },
    suggestAddr: function(text){
      let self = this;
      self.isRed = false;
      if(text.length > 2){
        self.updateVars()
        window.ymaps.suggest(text).then(function(res){
          self.suggestions = [{
            data: res
          }];
          console.log("suggestAddr");
          console.log(text);
          console.log(self.company);
          if (self.company.address === '' || self.company.address === undefined) {
            self.isNotEmpty = false;
          }else{
            self.isNotEmpty = true;
          }
        });
      }
    },
    updateVars: function(){
      this.loaded = false
      this.$emit("updatecompany", this.company)
      this.loaded = true
    },
    setPhone: function(phone){
      this.company.phone = phone;
      self.updateVars()
    },
    onSelected(option) {
      if(option.item){
        if(option.item.value){
          if(!this.company){
            this.company = {}
          }
          console.log("onSelected");
          console.log(this.company);
          this.company.address = option.item.value;
          this.updateVars()
        }
      }

    },
  },
  mounted(){
    if(this.company.name){
      let self = this;
      let searchurl = ""
      if(window.location.host.indexOf("localhost") > -1) {
        searchurl = 'http://localhost:3000/api/v1/companysearch/searchcontacts';
      }else{
        searchurl = 'https://editor.fo.ru/api/v1/companysearch/searchcontacts';
      }
      axios
      .post(searchurl, {companyname: this.company.name})
      .then(function (response) {
        if(response.data){
          if(response.data.features){
            if(response.data.features[0]){
              if(response.data.features[0].properties){
                if(response.data.features[0].properties["CompanyMetaData"]){
                  if(response.data.features[0].properties["CompanyMetaData"]["Phones"][0]){
                    self.setPhone(response.data.features[0].properties["CompanyMetaData"]["Phones"][0]["formatted"]);
                    // self.company.phone = response.data.features[0].properties["CompanyMetaData"]["Phones"][0]["formatted"];
                  }
                }
              }
            }
          }
        }
      })
    }
    console.log("1");
    console.log(this.company);
    if(this.company.address){
      if(this.company.address != ''){
        this.loaded = true
      }
    }
    console.log("2");
    console.log(this.company);
    if (this.company.address === '' || this.company.address === undefined) {
      this.isNotEmpty = false;
    }else{
      this.isNotEmpty = true;
    }
  }

}
</script>

<style lang="scss">
  .foruwizard-map{
    width: 386px;
    height: 240px;
    border: 1px solid rgba(0,0,0,0.24);
    border-radius: 4px;
  }
  .foruwizard-address-select .material-icons.q-icon.q-select__dropdown-icon{
    display: none;
  }

  .foruwizard-form-group-step-2{
  #autosuggest{
    position: relative;
    margin-bottom: 34px;
    #autosuggest__input + .autosuggest__results-container{
      &:before{
        content: "Адрес компании";
        font-family: 'MuseoSansCyrl', sans-serif;
        font-weight: 300;
        left: 17px;
        right: 0;
        top: -38px;
        color: rgba(0,0,0,0.6);
        font-size: 15px;
        line-height: 20px;
        text-decoration: inherit;
        text-transform: inherit;
        transform-origin: left top;
        position: absolute;
        transition: transform 0.36s cubic-bezier(0.4,0,0.2,1),right 0.36s cubic-bezier(0.4,0,0.2,1);
        pointer-events: none;
      }
    }
    #autosuggest__input:focus{
      line-height: 24px;
      padding-top: 24px;
      padding-bottom: 6px;
      color: #000 !important;
      & + .autosuggest__results-container{
        &:before{
          -webkit-transform: translate3d(0, -40%, 0) scale3d(0.75, 0.75, 0.75);
          transform: translate3d(0, -40%, 0) scale3d(0.75, 0.75, 0.75);
          right: -33.333333%;
          color: currentColor;
        }
      }
    }
    &.inputNotEmpty{
      #autosuggest__input{
        line-height: 24px;
        padding-top: 24px;
        padding-bottom: 6px;
        color: #000 !important;
        & + .autosuggest__results-container{
          &:before{
            -webkit-transform: translate3d(0, -40%, 0) scale3d(0.75, 0.75, 0.75);
            transform: translate3d(0, -40%, 0) scale3d(0.75, 0.75, 0.75);
            right: -33.333333%;
            color: currentColor;
          }
        }
      }
    }
    &.inputError #autosuggest__input{
      border-color: #c10015;
      line-height: 24px;
      padding-top: 24px;
      padding-bottom: 6px;
      color: #000 !important;
      & + .autosuggest__results-container{
        &:before{
          -webkit-transform: translate3d(0, -40%, 0) scale3d(0.75, 0.75, 0.75);
          transform: translate3d(0, -40%, 0) scale3d(0.75, 0.75, 0.75);
          right: -33.333333%;
          color: #c10015;
        }
        &:after{
          content: "Укажите адрес компании";
          font-family: 'MuseoSansCyrl', sans-serif;
          font-weight: 300;
          color: #c10015;
          font-size: 12px;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          padding: 8px 18px 0;
          display: block;
          top: 0;
        }
      }
    }
  }
  }
</style>
